import React, {
  useState,
  useEffect,
  useReducer,
  useRef,
  Suspense,
} from "react";
import { Button } from "devextreme-react/button";
import Gallery from "devextreme-react/gallery";
import { Popup, Position } from "devextreme-react/popup";
import { custom } from "devextreme/ui/dialog";
import NumberBox from "devextreme-react/number-box";
import ophReducer from "../../../reducers/oph";
import * as action from "../../../actions/oph";
import AsyncCallHandler from "../../../common/AsyncCallHandler";
import NEXUS_CONST from "../../../common/constants";
import { alert, confirm } from "devextreme/ui/dialog";
import { TagBox } from "devextreme-react/tag-box";
import DateBox from "devextreme-react/date-box";
import moment, { duration } from "moment";
// import { moment } from "moment-timezone";
import SelectBox from "devextreme-react/select-box";
import ProgressBar from "@ramonak/react-progress-bar";
import TextBox from "devextreme-react/text-box";
import ScrollView from "devextreme-react/scroll-view";
import TextArea from "devextreme-react/text-area";
import * as utils from "../../../common/utils";
import "../ophDashboard/ophDashboard.css";
import DataGrid, {
  Scrolling,
  Pager,
  Paging,
  ColumnFixing,
  Editing,
  FilterRow,
  Column,
  Toolbar,
  Item,
} from "devextreme-react/data-grid";
import { postUserLog } from "../../../actions/common";
import { isEditable, set, get } from "../../../common/utils";
import { compact, filter, isNumber, sumBy } from "lodash";
// import { toggleState } from "../../../reducers/slices/ophRefreshSlice";
// import { useDispatch } from "react-redux";

const initialOPHData = {
  ophValue: {
    siteId: "",
    tierid: "",
    plant: "",
    lineInfo: "",
    ophName: "",
    ophDate: "",
    operator: "",
    creationDate: null,
    taktTime: null,
    taktPeriod: null,
    totalTime: null,
    totalProduction: null,
    expectedProduction: null,
    taktAttainment: null,
    oph: [],
    materialList: [],

    level2List: [],
    ophTaktInfo: {},
  },
};

const OPHDashboard = (props) => {
  const {
    site,
    tier,
    ophList,
    ophId,
    setRefresh,
    setOPHId,
    missReasonCodes,
    siteDate,
    setSiteDate,
    isEditable,
    siteInformation,
    lastUpdatedOn,
    moduleTitle,
  } = { ...props };
  const [ophData, setOPHData] = useState();
  const [state, dispatch] = useReducer(ophReducer, initialOPHData);
  const {
    ophValue,
    materialList,

    level2List,
    ophTaktInfo,
    ophTaktdata,
  } = state;
  const [animate, setAnimate] = useState("");
  const [ophRefreshIns, setOphRefreshIns] = useState(null);
  const [measures, setMeasures] = useState({
    currentHour: 0,
    currentTS: 0,
    countDownTime: 0,
  });
  const [isCurrentDate, setIsCurrentDate] = useState(false);
  const [message, setMessage] = useState("");
  const [ophDate, setOPHDate] = useState(lastUpdatedOn);
  const [isStdDay, setStdDay] = useState(true);
  const missReasonDataRef = useRef(null);
  const [shiftScheduleDetails, setShiftScheduleDetails] = useState({
    quantity: 0,
    duration: 0,
    goal: 0,
    shifts: [],
    lstShift: [],
    visible: true,
    currenthrObj: {},
  });
  const REF_TIME = 15000;
  const ElapseDuration = 10000;
  const [selectedShift, setSelectedShift] = useState(0);
  const [passedTimeRange, setPassedTimeRange] = useState(false);
  const [popUpTimeRange, setPopUpTimeRange] = useState(false);
  const [totalProduction, setTotalProduction] = useState(0);
  const [expectedProd, setExpectedProd] = useState(0);
  const [noOfHits, setnoOfHits] = useState(0);
  const [noOfMiss, setnoOfMiss] = useState(0);
  const [hoursAttained, sethoursAttained] = useState(0);
  const [materials, setMaterial] = useState([]);
  const [matErrorInfo, setMatErrorInfo] = useState([]);
  const [matErrorReq, setMatErrorReq] = useState([]);
  const [productionAttainment, setProductionAttainment] = useState(0);
  const [refresIn, setRefreshIn] = useState(100);
  const [elapsedTime, setElapsedTime] = useState(REF_TIME);
  let ophDateToReferesh = new Date();
  let refreshIns = null;
  const ophRefreshRef = useRef(null);
  const refreshInRef = useRef(null);
  const [lastRefresh, setLastRefresh] = useState(
    moment(lastUpdatedOn).format(" hh:mm:ss a")
  );
  const [ophShiftInfo, setOphShiftInfo] = useState({});
  const loggedinUser = get("hid");

  const [showPopup, setShowPopup] = useState(false);
  const [selectedHour, setSelectedHour] = useState();
  const [ophMissReasonCode, setOPHMissReasonCode] = useState("");
  const utcOffset =
    siteInformation?.length > 0 ? siteInformation[0].utcOffset : "UTC+0000";
  const [isAutmatedLine, setisAutmatedLine] = useState(false);
  const [siteInfo, setsiteInfo] = useState({});

  const isObjectEmpty = (obj) => Object.keys(obj).length === 0;
  // const reduxDispatch = useDispatch();
  useEffect(() => {
    setMatErrorInfo([]);
    setMaterial([]);
    setMatErrorReq([]);
    if (selectedHour) {
      let shiftId = 0;
      if (ophShiftInfo && ophShiftInfo.ophdata) {
        let data = ophShiftInfo.ophdata.find((d) => {
          if (d.shiftNo == selectedHour.shiftNo) return d;
        });
        shiftId = data.shiftScheduleID;
        let urlProps = `${tier}&shiftScheduleID=${shiftId}&startTime=${
          selectedHour.startDateTime
        }&endTime=${selectedHour.endDateTime}&date=${moment(ophDate).format(
          "YYYY-MM-DD"
        )}`;
        action.getTaktCardInfo(dispatch, urlProps);
      }

      action.getMaterials(dispatch, tier);

      action.getLevel2(dispatch, tier);
    }
  }, [selectedHour]);

  useEffect(() => {
    if (
      ophTaktInfo &&
      ophTaktInfo.materials &&
      ophTaktInfo.materials.length > 0
    ) {
      setMaterial(
        ophTaktInfo.materials.map((d) => {
          d["target"] = Math.floor(d["target"]);
          return d;
        })
      );
    }
  }, [ophTaktInfo]);

  const minToSec = (min) => min * 60;

  const calcTarget = (i) => {
    let matLst = [...materials];
    let mat = matLst[i];
    if (mat.material && mat.runTime) {
      let matTaktTime = mat.material;
      mat["target"] = mat.runTime / minToSec(matTaktTime);
    }
  };

  const addMatDet = () => {
    let matList = [...materials];
    let matLen = matList.length;
    let maxRuntime = ophTaktInfo.cardInterval - ophTaktInfo.breakInterval;
    let runTime = maxRuntime;
    if (matLen == 1) runTime = maxRuntime - matList[0]["runTime"];
    if (matLen == 2)
      runTime = maxRuntime - (matList[0]["runTime"] + matList[1]["runTime"]);
    if (runTime < 0 || isNaN(runTime)) runTime = 0;
    let matDet = {
      material: "",
      target: 0,
      completed: 0,
      runTime: runTime.toFixed(2),
      tierMaterialId: 0,
      changeoverid: 0,
      reasons: [],
    };
    matList.push(matDet);
    setMaterial(matList);
  };

  const delMaterial = (i) => {
    let matLst = [...materials];
    matLst.splice(i, 1);
    setMaterial(matLst);
  };
  const delReason = (i, j) => {
    let matLst = [...materials];
    matLst[i]["reasons"].splice(j, 1);
    setMaterial(matLst);
  };

  const addReason = (i) => {
    let matList = [...materials];
    let missedQtyTotal = 0;
    matList[i]["reasons"].map((d) => {
      missedQtyTotal = missedQtyTotal + Number(d.missedQty);
    });
    let missQty = matList[i].target - matList[i].completed - missedQtyTotal;
    if (missQty < 0 || isNaN(missQty)) missQty = 0;
    matList[i]["reasons"].push({
      levle0: "",
      level1: "",
      //level2: "",
      missedQty: Math.floor(missQty),
      description: "",
      reasonId: "",
    });
    setMaterial(matList);
  };

  const getReasonIdByUsingValues = (reasons) => {
    reasons?.map((reason) => {
      const { level0, level1, level2 } = reason;

      const reasonCode = filter(level2List, (e) => {
        if (
          e.level0 === level0 &&
          e.value === level1 &&
          (level2 ? e.level2 === level2 : true)
        ) {
          return e.id;
        }
      });
      reason["reasonId"] = reasonCode[0]?.id;
    });
    return reasons;
  };

  const validateRunTime = () => {
    let isValid = true;
    let maxMins =
      Number(ophTaktInfo.cardInterval) - Number(ophTaktInfo.breakInterval);
    let matList = [...materials];
    let runTimes = 0;
    matList.map((mat) => {
      runTimes = runTimes + Number(mat.runTime);
    });
    if (runTimes != maxMins) {
      isValid = false;
      alert(
        "The sum of total Run Time should be " +
          maxMins +
          " minutes (" +
          ophTaktInfo.cardInterval +
          " mins - Break time).",
        "Alert"
      );
    }

    return isValid;
  };

  const isHourEnded = () =>
    moment(selectedHour.endDateTime) < moment(siteInfo.lastUpdatedDate);

  const validateReasonCodes = () => {
    let isValid = true;
    let matList = [...materials];
    let errorInfo = [];
    matList.map((mat, i) => {
      let resonsEntqnty = 0;
      let qty = 0;
      if (mat.reasons.length > 0) {
        mat.reasons.map((reason) => {
          resonsEntqnty += qty + Number(reason.missedQty);
        });
      }
      let totalResAndCom = Number(mat.completed) + resonsEntqnty;
      let missedQtyCnt = mat.target - Number(mat.completed);
      missedQtyCnt = missedQtyCnt.toFixed(2);

      let qtyAdded = 0;
      errorInfo[i] = "";

      if (isHourEnded() && totalResAndCom !== mat.target) {
        if (mat.reasons.length > 0) {
          mat.reasons.map((reason) => {
            qtyAdded = qtyAdded + Number(reason.missedQty);
          });

          if (Math.floor(qtyAdded) != Math.floor(missedQtyCnt)) {
            if (totalResAndCom >= mat.target) {
              isValid = false;
              errorInfo[i] =
                "Complete value is already greater than or equal to Target, Please check and adjust missed qty added.";
            } else {
              isValid = false;
              errorInfo[i] =
                "Sum of the missed qty of reason codes must equal to the difference of the Target and completed qty for the material";
            }
          }
        } else {
          if (totalResAndCom > mat.target) {
            isValid = true;

            return;
          }
          isValid = false;
          errorInfo[i] = "Please add reason for the missed quantity";
        }
      }
    });
    setMatErrorInfo(errorInfo);
    return isValid;
  };

  const validateEmpty = () => {
    let isValid = true;
    let matList = [...materials];
    let errorInfo = [];
    matList.map((mat, i) => {
      errorInfo[i] = { m: "", r: "" };
      if (
        !mat.material ||
        mat.completed < 0 ||
        mat.completed === "" ||
        mat.target < 0 ||
        mat.target === "" ||
        mat.runTime < 0 ||
        mat.runTime === ""
      ) {
        isValid = false;
        errorInfo[i]["m"] = "Please select the Material.";
      }
      if (mat.reasons.length > 0) {
        mat.reasons.map((reason) => {
          if (!reason.level0 || reason.missedQty < 0) {
            isValid = false;
            errorInfo[i]["r"] =
              "All fields are required for reason codes except Description.";
          }
        });
      }
    });
    setMatErrorReq(errorInfo);
    return isValid;
  };

  const updateMatTarget = (i, mat, runtime) => {
    if (mat && runtime) {
      let matInfo = materialList.find((d) => d.materialID == mat);
      if (matInfo) {
        //eslint-disable-next-line
        matInfo.taktTime; // in seconds
        let target = minToSec(runtime) / matInfo.taktTime;
        let matLst = [...materials];
        matLst[i]["target"] = Math.floor(target);
        setMaterial(matLst);
      }
    }
  };

  const handleIsCurrentDate = (ophDate) => {
    let currentDate = moment(new Date()).format("MM/DD/YYYY");
    if (currentDate === ophDate) {
      setIsCurrentDate(true);
    } else {
      setIsCurrentDate(false);
    }
  };

  const calcRemainingCDTime = (hh, mm, ss) => {
    let _remainingTimeSec = 3600 - parseInt(mm) * 60 - parseInt(ss);
    let mmRemaining = parseInt(_remainingTimeSec / 60);
    if (mmRemaining < 10) {
      mmRemaining = "0" + mmRemaining;
    }
    let ssRemaining = _remainingTimeSec % 60;
    if (ssRemaining < 10) {
      ssRemaining = "0" + ssRemaining;
    }
    return `${"00"}:${mmRemaining}:${ssRemaining}`;
  };
  const onOphRefresh = () => {
    AsyncCallHandler(
      NEXUS_CONST.FETCH_OPH_DASHBOARD_DATA +
        site +
        "&tierId=" +
        tier +
        "&userID=" +
        loggedinUser +
        "&isStdDay=" +
        1 + // Need to remove this when removed from API E452130
        "&date=" +
        moment(ophDate).format("YYYY-MM-DD"),

      NEXUS_CONST.GET
    ).then((res) => {
      setOphShiftInfo(res.data);
      if (res.data.length !== 0) {
        let i = 0;
        let arrShift = [];
        if (res?.data?.ophdata) {
          arrShift = res?.data?.ophdata.map(
            ({ shiftName, shiftNo, shiftHours }) => ({
              label: shiftName,
              id: shiftNo,
              duration: shiftHours,
            })
          );
        }
        setOPHId(utils.getRandomNum());

        arrShift.unshift({
          label: "All",
          id: 0,
          duration: res?.data?.targetActualInfo?.length,
        });

        let currentObj =
          res?.data?.targetActualInfo?.find(
            (data) => data.currentHour === 1
          ) !== undefined
            ? res?.data?.targetActualInfo?.find(
                (data) => data.currentHour === 1
              )
            : {};

        setisAutmatedLine(
          res?.data?.targetActualInfo.length > 0
            ? res?.data?.targetActualInfo[0].lineDetails !== "Manual"
            : false
        );

        setShiftScheduleDetails({
          lstShift: arrShift,
          currenthrObj: currentObj,
        });
        setOPHData(res?.data?.targetActualInfo);
      }
    });
    setLastRefresh(moment(lastUpdatedOn).format(" hh:mm:ss a"));
    //setOPHId(utils.getRandomNum())
  };
  const calcMeasuresWithDate = (newDate) => {
    let dateTime = newDate
      ? new Date(newDate).toLocaleString("en-US", { hour12: false })
      : new Date().toLocaleString("en-US", { hour12: false });
    let [date, hh, mm, ss] = [
      dateTime.slice(0, 10),
      ...dateTime.slice(11).split(":"),
    ];
    if (hh === "24") {
      hh = "00";
    }
    let _currentTS = `${date} ${hh}:${mm}:${ss}`;
    let remainingCDTime = calcRemainingCDTime(hh, mm, ss);
    setMeasures({
      ...measures,
      currentHour: hh,
      currentTS: _currentTS,
      countDownTime: remainingCDTime,
    });
  };

  const initProgressRef = () => {
    refreshInRef.current = setInterval(() => {
      {
        let elpTime = get("elapsedTime");
        let elapsed = elpTime - ElapseDuration;
        let percent = (elapsed / REF_TIME) * 100;
        setRefreshIn(percent.toFixed(0));
        set("elapsedTime", elapsed);
      }
    }, ElapseDuration);
  };

  useEffect(() => {
    // if (isAutmatedLine) {
    ophRefreshRef.current = setInterval(() => onOphRefresh(), REF_TIME);
    initProgressRef();
    set("elapsedTime", REF_TIME);
    // }
    return () => {
      clearInterval(ophRefreshRef.current);
      clearInterval(refreshInRef.current);
    };
  }, [ophDate, tier]);

  // useEffect(() => {
  //   action.fetchOPHDetails(
  //     dispatch,
  //     site,
  //     tier,
  //     moment(ophDate).format("YYYY-MM-DD"),
  //     isStdDay
  //   );

  //   if (
  //     moment(ophDate).format("YYYY-MM-DD") !=
  //     moment(new Date()).format("YYYY-MM-DD")
  //   ) {
  //     clearInterval(ophRefreshRef.current);
  //     clearInterval(refreshInRef.current);

  //     refreshInRef.current = 0;
  //     ophRefreshRef.current = 0;
  //   }
  //   if (
  //     moment(ophDate).format("YYYY-MM-DD") ==
  //       moment(new Date()).format("YYYY-MM-DD") &&
  //     !ophRefreshRef.current
  //   ) {
  //     ophRefreshRef.current = setInterval(() => refreshOph(), REF_TIME);
  //     initProgressRef();
  //   }
  // }, [ophDate]);

  // useEffect(() => {
  //   if (ophValue.ophdate)
  //     if (ophId == null && ophValue.ophdate !== undefined) {
  //       var newVal = moment(new Date()).format("MM/DD/YYYY");
  //       if (ophValue.ophdate === newVal) {
  //         setOPHId(ophValue.prodId);
  //       }
  //       handleIsCurrentDate(ophValue.ophdate);
  //     }
  // }, [ophValue]);

  const onValueChanged = (data) => {
    setOPHDate(new Date(data.value));
    setSiteDate(data.value);
    setOPHId(utils.getRandomNum());
    calcMeasuresWithDate(data.value, "");
    postUserLog({
      event: "Date Selection",
      data: {
        action: moment(data.value).format("MM/DD/YY") + " Date selected",
        module: "Digital Tier",
        section: moduleTitle,
        siteUId: site,
        widget: "OPH TRACKER",
        tierId: tier,
      },
    });
  };

  useEffect(() => {
    // if (
    //   moment(ophDate).format("YYYY/MM/DD") <
    //   moment(new Date()).format("YYYY/MM/DD")
    // ) {
    //   if (ophData !== null) {
    //     setnoOfHits(0);
    //     setnoOfMiss(ophData?.noOfMis);
    //   }
    // } else
    if (
      moment(ophDate).format("YYYY/MM/DD") >
      moment(new Date()).format("YYYY/MM/DD")
    ) {
      if (ophData !== null) {
        setnoOfHits(0);
        setnoOfMiss(0);
        sethoursAttained(0);
        setSiteDate(new Date(ophDate));
        setOPHId(utils.getRandomNum());
      }
    }
  }, [ophData]);

  // We need to remove this extra call as we are getting in single call E452130
  // useEffect(() => {
  //   if (ophValue.siteId) {
  //     setOPHData({ ...ophValue });

  //     updateOPHParameter(selectedShift, { ...ophValue });
  //     if (ophId == null && ophValue.ophdate !== undefined) {
  //       var newVal = moment(new Date()).format("DD/MM/YYYY");
  //       if (ophValue.ophdate === newVal) {
  //         setOPHId(ophValue.prodId);
  //       }
  //     }
  //     handleIsCurrentDate(ophValue.ophdate);
  //   }
  // }, [ophValue, shiftScheduleDetails]);
  useEffect(() => {
    AsyncCallHandler(
      NEXUS_CONST.GET_TIER_INFO + `siteid=${site}&tierid=${tier}`,
      NEXUS_CONST.GET
    ).then((res) => {
      setsiteInfo(res.data);
      setOPHId(utils.getRandomNum());

      // setOPHDate(new Date(res.data.lastUpdatedDate));
    });
  }, [showPopup, ophTaktdata]);

  useEffect(() => {
    AsyncCallHandler(
      NEXUS_CONST.FETCH_OPH_DASHBOARD_DATA +
        site +
        "&tierId=" +
        tier +
        "&userID=" +
        loggedinUser +
        "&isStdDay=" +
        1 + // Need to remove this when removed from API E452130
        "&date=" +
        moment(ophDate).format("YYYY-MM-DD"),

      NEXUS_CONST.GET
    ).then((res) => {
      setOphShiftInfo(res.data);
      setOPHId(utils.getRandomNum());

      if (res.data.length !== 0) {
        let i = 0;
        let arrShift = [];
        if (res?.data?.ophdata) {
          arrShift = res?.data?.ophdata.map(
            ({ shiftName, shiftNo, shiftHours }) => ({
              label: shiftName,
              id: shiftNo,
              duration: shiftHours,
            })
          );
        }

        arrShift.unshift({
          label: "All",
          id: 0,
          duration: res?.data?.targetActualInfo?.length,
        });

        let currentObj =
          res?.data?.targetActualInfo?.find(
            (data) => data.currentHour === 1
          ) !== undefined
            ? res?.data?.targetActualInfo?.find(
                (data) => data.currentHour === 1
              )
            : {};

        setisAutmatedLine(
          res?.data?.targetActualInfo.length > 0
            ? res?.data?.targetActualInfo[0].lineDetails !== "Manual"
            : false
        );

        setShiftScheduleDetails({
          lstShift: arrShift,
          currenthrObj: currentObj,
        });
        setOPHData(res?.data?.targetActualInfo);
      }
    });
  }, [ophDate, showPopup, ophTaktdata, tier]);

  useEffect(() => {
    updateOPHParameter(selectedShift, ophData);
    setOPHId(utils.getRandomNum());
  }, [ophData]);

  // We need to replace this with above one E452130
  // useEffect(() => {
  //   AsyncCallHandler(
  //     NEXUS_CONST.FETCH_SHIFTSCHEDULE +
  //       site +
  //       "&tierId=" +
  //       tier +
  //       "&isStdDay=" +
  //       isStdDay +
  //       "&date=" +
  //       moment(ophDate).format("YYYY-MM-DD"),

  //     NEXUS_CONST.GET
  //   ).then((res) => {
  //     if (res.data.length != 0) {
  //       let i = 0;
  //       let arrShift = [];
  //       for (i = 0; i < res.data.quantity; i++) {
  //         arrShift[i] = { label: `Shift-${i + 1}`, id: 1 + i };
  //       }
  //       arrShift.unshift({ label: "All", id: 0 });

  //       setShiftScheduleDetails({
  //         quantity: res.data.quantity,
  //         duration: res.data.duration,
  //         goal: res.data.goal,
  //         shifts: res.data.shifts,
  //         lstShift: arrShift,
  //       });
  //     }
  //   });
  // }, [ophDate]);

  useEffect(() => {
    setTimeout(() => {
      setAnimate("animate");
    }, 250);
  }, []);

  function compareDatetime(datetimeStr1, datetimeStr2, datetimeStr3) {
    const format = "YYYY-MM-DDTHH:mm:ss";

    const moment1 = moment(datetimeStr1, format); //curr
    const moment2 = moment(datetimeStr2, format); //start
    const moment3 = moment(datetimeStr3, format); //end

    if (moment1.isBefore(moment2) && !moment1.isBetween(moment2, moment3)) {
      return false;
    } else if (
      moment1.isAfter(moment2) &&
      !moment1.isBetween(moment2, moment3)
    ) {
      return true;
    } else if (moment1.isBetween(moment2, moment3)) {
      return false;
    }
  }

  const getCurrentTimeInTimeZone = (targetTimezoneOffset) => {
    // Get the current system time
    const currentSystemTime = moment();

    // Calculate the target time
    const targetTime = currentSystemTime
      .clone()
      .utcOffset(targetTimezoneOffset);

    return targetTime.format("YYYY-MM-DD HH:mm:ss"); // You can format the output as desired
  };

  //Function to get background color of the takt card
  const getBackGroundColor = (data) => {
    let dataToCompare = !isObjectEmpty(shiftScheduleDetails?.currenthrObj)
      ? shiftScheduleDetails?.currenthrObj?.startDateTime
      : siteInfo.lastUpdatedDate;

    let isCurrentGrater = compareDatetime(
      dataToCompare,
      data.startDateTime,
      data.endDateTime
    );

    if (data.actual < data.target && isCurrentGrater) {
      return "#ff584d";
    } else if (data.actual >= data.target && isCurrentGrater) {
      return "#77d482";
    } else {
      return "gray";
    }
  };

  let hitIncrement = 0;
  let missincrement = 0;
  const checkColor = (data, startTime, endTime) => {
    const currentTime = convertTo24HourFormat(
      new Date().toLocaleTimeString().replace(/(.*)\D\d+/, "$1")
    );
    const convertedStartTime = convertTo24HourFormat(startTime);
    const convertedEndTime = convertTo24HourFormat(endTime);

    if (isCurrentDate) {
      if (
        currentTime >= convertedEndTime &&
        data.completed / data.target >= 1
      ) {
        hitIncrement = noOfHits + 1;
        return "#1f6127";
      } else if (
        currentTime >= convertedEndTime &&
        data.completed / data.target < 1
      ) {
        missincrement = missincrement + 1;

        return "#800800";
      } else if (
        convertedStartTime <= currentTime &&
        currentTime <= convertedEndTime &&
        data.completed / data.target >= 1
      ) {
        return "#1f6127";
      } else if (
        convertedStartTime <= currentTime &&
        currentTime <= convertedEndTime &&
        data.completed / data.target < 1
      ) {
        missincrement = missincrement + 1;

        return "#800800";
      } else {
        return "#dedede";
      }
    } else {
      if (data.completed / data.target >= 1) {
        return "#1f6127";
      } else if (data.completed / data.target < 1) {
        return "#800800";
      } else {
        return "#dedede";
      }
    }
  };

  const convertTo24HourFormat = (time) => {
    var hours = Number(time?.match(/^(\d+)/)[1]);
    var minutes = Number(time?.match(/:(\d+)/)[1]);
    var AMPM = time?.match(/\s(.*)$/)[1];
    if (AMPM == "PM" && hours < 12) hours = hours + 12;
    if (AMPM == "AM" && hours == 12) hours = hours - 12;
    var sHours = hours.toString();
    var sMinutes = minutes.toString();
    if (hours < 10) sHours = 0 + sHours;
    if (minutes < 10) sMinutes = 0 + sMinutes;
    return sHours + ":" + sMinutes;
  };

  const getStylevalue = (data) => {
    let style = {};

    if (isAutmatedLine && data.hasReasonCode === 1) {
      style = {
        backgroundColor: getBackGroundColor(data),
        height: "140px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        padding: ".5rem",
        borderRadius: ".5rem",
        cursor: "pointer",
        gap: "1rem",
        animation:
          getBackGroundColor(data) === "#ff584d"
            ? "blinkingText 2s infinite"
            : "",
      };
    } else {
      style = {
        backgroundColor: getBackGroundColor(data),
        height: "140px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        padding: ".5rem",
        borderRadius: ".5rem",
        cursor: "pointer",
        gap: "1rem",
      };
    }
    return style;
  };

  const ItemRender = (data, index, element) => {
    var startTime = data.startTime + " AM";

    const [time, ampm] = startTime.split(" ");
    const [hours, minutes] = time.split(":").map(Number);

    const date = new Date();
    date.setHours(hours, minutes + 60); // Add one hour (60 minutes)

    const resultHours = date.getHours();
    const resultMinutes = date.getMinutes();
    const resultAMPM = resultHours < 12 ? "AM" : "PM";

    const resultTimeString = `${resultHours % 12 || 12}:${resultMinutes
      .toString()
      .padStart(2, "0")} ${resultAMPM}`;

    var endTime = resultTimeString;

    return (
      <>
        <div style={{ borderRadius: ".5rem", padding: "5px", width: "110px" }}>
          <div
            key={data.hourSlot}
            style={getStylevalue(data)}
            onClick={() => handlePopupOpen(data, startTime, endTime)}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: ".25rem",
              }}
            >
              <h6>
                {data.startTime}-
                {moment(data.endDateTime).add(1, "minutes").format("h:mm A")}
              </h6>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {data.actual !== null ? (
                <div
                  style={{
                    fontSize: "2rem",
                    lineHeight: "3.5rem",
                  }}
                >
                  <b>{data.actual}</b>
                </div>
              ) : data.actual !== null ? (
                <div
                  style={{
                    fontSize: "2rem",
                    lineHeight: "3.5rem",
                  }}
                >
                  <b>{data.actual}</b>
                </div>
              ) : (
                <div
                  className="dx-icon-edit"
                  style={{ fontSize: "3rem", lineHeight: "3.5rem" }}
                ></div>
              )}
              <div
                style={{
                  height: ".25rem",
                  width: "50px",
                  backgroundColor: "orange",
                }}
              ></div>
              <div style={{ fontSize: "2rem" }}>{data.target}</div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const handlePopupOpen = (data, startTime, endTime) => {
    setSelectedHour({ ...data });
    AsyncCallHandler(
      NEXUS_CONST.FETCH_OPH_MISS_REASON_CODE_DETAILS_BY_ID +
        data.id +
        "&tierId=" +
        tier +
        "&prodId=" +
        ophValue.prodId,
      NEXUS_CONST.GET
    ).then((res) => {
      if (res.status === 200) {
        setOPHMissReasonCode(res.data);
        setOPHId(utils.getRandomNum());
      }
    });
    setShowPopup(true);
  };

  const handlePopupClose = () => {
    setSelectedHour();
    setMessage("");
    setShowPopup(false);
    setPassedTimeRange(false);
    setPopUpTimeRange(false);
    setOPHId(utils.getRandomNum());
  };

  const onShiftChange = (data) => {
    setSelectedShift(data.value);
    let shiftSelectionValue =
      data.value !== 0
        ? `${shiftScheduleDetails.lstShift[data.value]["label"]} selected`
        : "All Shifts selected";
    postUserLog({
      event: "Shift Selection",
      data: {
        action: shiftSelectionValue,
        module: "Digital Tier",
        section: moduleTitle,
        siteUId: site,
        widget: "OPH TRACKER",
        tierId: tier,
      },
    });

    updateOPHParameter(data.value, ophData);
  };
  const updateOPHParameter = (val, ophData) => {
    let sliceData = [];
    if (val === 0) {
      sliceData = ophData ? ophData : "";
    } else {
      sliceData = ophData?.filter((data) => data.shiftNo === val);
    }

    let hitcount = calculateAttainmentCount(sliceData);
    let totalProd = calculateTotalProduction(sliceData);
    let expectProd = calculateExpecProduction(sliceData);

    let totalProdforCurrenthr =
      calculateTotalProductionforcurrenthour(sliceData);
    let expectProdforCurrenthr =
      calculateExpecProductionforcurrenthour(sliceData);

    setTotalProduction(totalProd);
    setExpectedProd(expectProd);
    setProductionAttainment(
      calcTaktAttainment(totalProdforCurrenthr, expectProdforCurrenthr)
    );
  };

  const calculateAttainmentCount = (sliceData) => {
    if (sliceData && sliceData.length > 0) {
      let count = 0;
      let countmiss = 0;
      if (
        moment(ophDate).format("YYYY/MM/DD") <
        moment(new Date()).format("YYYY/MM/DD")
      ) {
        sliceData.forEach((item) => {
          if (item.actual >= item.target) {
            count++;
          } else if (item.actual < item.target) {
            countmiss++;
          }
        });

        setnoOfHits(count);
        setnoOfMiss(countmiss);
      }

      if (
        moment(ophDate).format("YYYY/MM/DD") ==
          moment(new Date()).format("YYYY/MM/DD") &&
        Array.isArray(sliceData)
      ) {
        sliceData.forEach((item) => {
          let dataToCompare = !isObjectEmpty(shiftScheduleDetails?.currenthrObj)
            ? shiftScheduleDetails?.currenthrObj?.startDateTime
            : siteInfo.lastUpdatedDate;
          let isCurrentGrater = compareDatetime(
            dataToCompare,
            item.startDateTime,
            item.endDateTime
          );

          if (item.actual < item.target && isCurrentGrater) {
            countmiss++;
          } else if (item.actual >= item.target && isCurrentGrater) {
            count++;
          }
        });

        setnoOfHits(count);
        setnoOfMiss(countmiss);
      }
      if (count !== 0) {
        const calculatehoursAttained = (count / (count + countmiss)) * 100;
        sethoursAttained(calculatehoursAttained);
      } else {
        sethoursAttained(0);
      }
    }
  };

  const handleSave = () => {
    let isAllFilled = validateEmpty();
    let isValidRunTime = validateRunTime();
    let isValidReasons = validateReasonCodes();
    if (!isAllFilled || !isValidRunTime || !isValidReasons) return;
    let meterialInfo = [...materials];
    meterialInfo.map((material) => {
      material = getReasonIdByUsingValues(material.reasons);
    });
    let payload = ophTaktInfo;
    payload.materials = meterialInfo;
    payload.tStartTime = selectedHour.startDateTime;
    payload.tEndTime = selectedHour.endDateTime;
    payload.tabName = moduleTitle;
    action.saveTaktMaterialInfo(dispatch, payload);
    // setOPHId(true);
    setOPHId(utils.getRandomNum());

    handlePopupClose();

    // reduxDispatch(toggleState());
  };

  const isShiftVisible = (index) => {
    if (selectedShift == 0) return true;
    else return selectedShift === index;
  };

  const calculateTotalProduction = (ophData) => {
    let _total = ophData ? ophData?.reduce((a, c) => a + c.actual, 0) : 0;
    return _total;
  };
  const calculateExpecProduction = (ophData) => {
    let _expecProductionValue = ophData
      ? ophData?.reduce((a, c) => a + c.target, 0)
      : 0;
    return Math.round(_expecProductionValue, 0);
  };

  const calculateTotalProductionforcurrenthour = (ophData) => {
    let dataToCompare = !isObjectEmpty(shiftScheduleDetails?.currenthrObj)
      ? shiftScheduleDetails?.currenthrObj?.startDateTime
      : siteInfo.lastUpdatedDate;

    let _total = 0;
    for (var i = 0; i < ophData.length; i++) {
      let isCurrentGrater = compareDatetime(
        dataToCompare,
        ophData[i].startDateTime,
        ophData[i].endDateTime
      );
      if (ophData && isCurrentGrater) {
        _total += ophData[i].actual;
      }
    }
    return _total;
  };
  const calculateExpecProductionforcurrenthour = (ophData) => {
    let dataToCompare = !isObjectEmpty(shiftScheduleDetails?.currenthrObj)
      ? shiftScheduleDetails?.currenthrObj?.startDateTime
      : siteInfo.lastUpdatedDate;

    let _expecProductionValue = 0;
    for (var i = 0; i < ophData.length; i++) {
      let isCurrentGrater = compareDatetime(
        dataToCompare,
        ophData[i].startDateTime,
        ophData[i].endDateTime
      );

      if (ophData && isCurrentGrater) {
        _expecProductionValue += ophData[i].target;
      }
    }
    return Math.round(_expecProductionValue, 0);
  };

  const calcTaktAttainment = (totalProduction, expectedProduction) => {
    let percAttainment =
      expectedProduction == 0
        ? 0
        : (totalProduction / expectedProduction) * 100;
    return percAttainment;
  };

  const isAutoMatExist = () =>
    selectedHour && selectedHour.lineDetails == "Auto" && selectedHour.lineName;

  return (
    <section className="page-content">
      <div className="site-view tier-wrap admin-console-wrapper">
        <div className={"site-list " + animate}>
          {isAutmatedLine && (
            <>
              <div className="last-ref-d">Last refreshed: {lastRefresh}</div>
              <div className="oph-timer">
                <i
                  title="Refresh"
                  className="fas  fa-sync"
                  onClick={onOphRefresh}
                ></i>{" "}
                <br />
                <ProgressBar
                  animateOnRender={true}
                  completed={refresIn}
                  customLabel=" "
                  height="8px"
                  width="80px"
                  borderRadius="0"
                  bgColor="#0078C2"
                />
              </div>
            </>
          )}
          <div
            style={{
              width: "100%",
              padding: ".25rem 2rem",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <div
              style={{ width: "15%", padding: "20px", justifyContent: "left" }}
            >
              <SelectBox
                dataSource={shiftScheduleDetails.lstShift}
                onValueChanged={onShiftChange}
                valueExpr="id"
                displayExpr="label"
                value={selectedShift}
              />
            </div>
            <div
              style={{
                width: "100%",
                padding: ".25rem 2rem",
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              {siteInfo.lastUpdatedDate !== undefined ? (
                <DateBox
                  defaultValue={new Date(siteInfo?.lastUpdatedDate)}
                  onValueChanged={onValueChanged}
                  type="date"
                />
              ) : (
                ""
              )}
              {!isAutmatedLine && <h2>{measures.currentTS}</h2>}
            </div>
          </div>

          {
            <>
              <div className="raiseci-section" style={{ paddingTop: "1rem" }}>
                <div className="page-heading">
                  <h3 style={{ color: "gray" }}>
                    TOTAL PRODUCTION :{" "}
                    <span style={{ color: "white", fontSize: "1.25rem" }}>
                      {totalProduction}
                    </span>
                  </h3>
                </div>
                <div className="page-heading">
                  <h3 style={{ color: "gray" }}>
                    PRODUCTION ATTAINMENT :{" "}
                    <span style={{ color: "white", fontSize: "1.25rem" }}>
                      {productionAttainment.toFixed(2)} %
                    </span>
                  </h3>
                </div>
              </div>

              <div className="raiseci-section">
                <div className="page-heading">
                  <h3 style={{ color: "gray" }}>
                    EXPEC PRODUCTION :{" "}
                    <span style={{ color: "white", fontSize: "1.25rem" }}>
                      {expectedProd}
                    </span>
                  </h3>
                </div>
                <div className="page-heading">
                  <div style={{ display: "flex" }}>
                    {!isAutmatedLine && (
                      <>
                        <h3 style={{ color: "gray" }}>
                          HOURS HIT :{" "}
                          <span
                            style={{
                              color: "rgb(119, 212, 130)",
                              fontSize: "1.25rem",
                            }}
                          >
                            {noOfHits}&nbsp;&nbsp;
                          </span>
                        </h3>
                        <h3 style={{ color: "gray" }}>
                          HOURS MISSED :{" "}
                          <span
                            style={{
                              color: "rgb(255, 88, 77)",
                              fontSize: "1.25rem",
                            }}
                          >
                            {noOfMiss}&nbsp;&nbsp;
                          </span>
                        </h3>
                      </>
                    )}
                    <h3 style={{ color: "gray" }}>
                      HOURS ATTAINED :{" "}
                      <span style={{ color: "white", fontSize: "1.25rem" }}>
                        {hoursAttained.toFixed(2)} %
                      </span>
                    </h3>
                  </div>
                </div>
              </div>
              <div className="raiseci-section" style={{ paddingTop: "1rem" }}>
                <div className="page-heading">
                  <h3 style={{ color: "gray" }}>
                    CURRENT MATERIAL :{" "}
                    <span
                      style={{
                        color: "white",
                        fontSize: "1.25rem",
                      }}
                    >
                      {!isObjectEmpty(shiftScheduleDetails?.currenthrObj)
                        ? shiftScheduleDetails?.currenthrObj?.materialNo
                        : ophData !== undefined && ophData.length > 0
                        ? ophData[ophData.length - 1].materialNo
                        : 0}
                    </span>
                  </h3>
                </div>
              </div>

              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  padding: ".5rem 1rem",
                }}
              >
                <h2>OPH - {moment(ophDate).format("MM/DD/YYYY")}</h2>
              </div>

              <div>
                {shiftScheduleDetails?.lstShift?.map((shift, index) => {
                  let sliceData = [];

                  sliceData = ophData?.filter(
                    (oph) => oph.shiftNo === shift.id
                  );

                  if (shift.id !== 0) {
                    return (
                      <div
                        style={{
                          display: "flex",
                          flex: "row",
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            whiteSpace: "nowrap",
                          }}
                        >
                          <h3 style={{ width: "100%" }}>
                            {isShiftVisible(shift.id) ? shift.label : ""}
                          </h3>
                        </div>

                        <div
                          style={{
                            width: "100%",
                            overflow: "hidden",
                          }}
                        >
                          <Gallery
                            dataSource={sliceData}
                            height={160}
                            width="100%"
                            showNavButtons={true}
                            showIndicator={false}
                            itemRender={ItemRender}
                            wrapAround={true}
                            initialItemWidth={120}
                            visible={isShiftVisible(shift.id)}
                            hint={`Shift ${shift.id}`}
                          />
                        </div>
                      </div>
                    );
                  } else return null;
                })}
              </div>

              {selectedHour && (
                <>
                  <div className="ophPopup">
                    <Popup
                      visible={showPopup}
                      onHiding={handlePopupClose}
                      showCloseButton={true}
                      showTitle={true}
                      title={"OPH Details - " + selectedHour.boxNumber + "H"}
                      width={"75%"}
                      height={"auto"}
                      dragEnabled={true}
                      minHeight={"150px"}
                    >
                      <Position at="center" my="center" />

                      <div
                        className="posts-scroll-view"
                        width="100%"
                        // height="100%"
                      >
                        <ScrollView
                          id="sitecontent"
                          // {...{
                          //   showScrollbar: "always",
                          //   scrollByContent: true,
                          //   scrollByThumb: true,
                          // }}
                          style={{ paddingbottom: "5px" }}
                        >
                          <div
                            className="material-blk"
                            style={{ marginRight: "12px" }}
                          >
                            {materials?.length < 3 && !isAutoMatExist() && (
                              <div className="add-mat">
                                <span onClick={addMatDet}>
                                  <i
                                    className="fas fa-plus safetyAlert"
                                    title="Add Material"
                                  ></i>{" "}
                                  Changeover check{" "}
                                </span>
                              </div>
                            )}
                            {materials?.map((mat, i) => {
                              return (
                                <div className="material-row shft-crd" key={i}>
                                  {!isAutoMatExist() && (
                                    <div className="shft-del-btn">
                                      <span onClick={() => delMaterial(i)}>
                                        <i className="dx-link dx-link-delete dx-icon-trash dx-link-icon " />{" "}
                                      </span>
                                    </div>
                                  )}

                                  <div className="mat-inputs">
                                    <SelectBox
                                      dataSource={materialList}
                                      labelMode={"floating"}
                                      wrapItemText={true}
                                      label="Material"
                                      displayExpr="materialNumber"
                                      valueExpr="materialID"
                                      searchEnabled={true}
                                      onValueChanged={(e) => {
                                        let matLst = [...materials];
                                        matLst[i]["material"] = e.value;
                                        updateMatTarget(
                                          i,
                                          e.value,
                                          mat.runTime
                                        );
                                        setMaterial(matLst);
                                      }}
                                      value={mat.material}
                                    />

                                    <NumberBox
                                      name="target"
                                      type="number"
                                      labelMode={"floating"}
                                      label="Target"
                                      disabled={isAutoMatExist()}
                                      format="#0"
                                      value={mat.target}
                                      onValueChanged={(e) => {
                                        let matLst = [...materials];
                                        matLst[i]["target"] = e.value;
                                        setMaterial(matLst);
                                      }}
                                      min={0}
                                      width={"15%"}
                                    />

                                    <NumberBox
                                      name="completed"
                                      type="number"
                                      format="#0"
                                      labelMode={"floating"}
                                      label="Completed"
                                      disabled={isAutoMatExist()}
                                      value={mat.completed}
                                      onValueChanged={(e) => {
                                        let matLst = [...materials];
                                        matLst[i]["completed"] = e.value;
                                        setMaterial(matLst);
                                      }}
                                      min={0}
                                      width={"15%"}
                                    />

                                    <NumberBox
                                      type="number"
                                      labelMode={"floating"}
                                      label="Run time (Minutes)"
                                      value={mat.runTime}
                                      format="#0.##"
                                      disabled={isAutoMatExist()}
                                      onValueChanged={(e) => {
                                        let matLst = [...materials];
                                        matLst[i]["runTime"] = e.value;
                                        updateMatTarget(
                                          i,
                                          mat.material,
                                          e.value
                                        );
                                        setMaterial(matLst);
                                      }}
                                      min={0}
                                      max={60}
                                      width={"15%"}
                                    />
                                  </div>
                                  <div>
                                    {matErrorReq[i] && matErrorReq[i].m && (
                                      <span className="err-lbl">
                                        {matErrorReq[i]["m"]}
                                      </span>
                                    )}
                                  </div>
                                  <div className="reasons">
                                    <div className="reason-head">
                                      <h3>Reason Code</h3>
                                      {mat["reasons"].length < 5 && (
                                        <span onClick={() => addReason(i)}>
                                          <i
                                            className="fas fa-plus safetyAlert"
                                            title="Add Reason Code"
                                          ></i>{" "}
                                          Add Reason Code
                                        </span>
                                      )}
                                    </div>

                                    {mat["reasons"] &&
                                      mat["reasons"].map((reason, j) => {
                                        return (
                                          <div className="mat-inputs" key={j}>
                                            <SelectBox
                                              dataSource={
                                                level2List
                                                  ? compact([
                                                      ...new Set(
                                                        level2List.map(
                                                          (d) => d.level0
                                                        )
                                                      ),
                                                    ])
                                                  : []
                                              }
                                              labelMode={"floating"}
                                              wrapItemText={true}
                                              label="Level 0"
                                              value={reason.level0}
                                              searchEnabled={true}
                                              onValueChanged={(e) => {
                                                let matLst = [...materials];
                                                matLst[i]["reasons"][j][
                                                  "level0"
                                                ] = e.value;
                                                matLst[i]["reasons"][j][
                                                  "reasonId"
                                                ] = "";

                                                setMaterial(matLst);
                                              }}
                                            />

                                            <SelectBox
                                              dataSource={
                                                level2List
                                                  ? compact([
                                                      ...new Set(
                                                        level2List.map((d) => {
                                                          if (
                                                            d.level0 ==
                                                            reason.level0
                                                          )
                                                            return d.value;
                                                        })
                                                      ),
                                                    ])
                                                  : []
                                              }
                                              labelMode={"floating"}
                                              wrapItemText={true}
                                              label="Level 1"
                                              searchEnabled={true}
                                              value={reason.level1}
                                              onValueChanged={(e) => {
                                                let matLst = [...materials];
                                                matLst[i]["reasons"][j][
                                                  "level1"
                                                ] = e.value;
                                                matLst[i]["reasons"][j][
                                                  "reasonId"
                                                ] = reason.reasonId;
                                                setMaterial(matLst);
                                              }}
                                            />
                                            <SelectBox
                                              dataSource={
                                                level2List
                                                  ? compact([
                                                      ...new Set(
                                                        level2List.map((d) => {
                                                          if (
                                                            d.value ===
                                                            reason.level1
                                                          )
                                                            return d.level2;
                                                        })
                                                      ),
                                                    ])
                                                  : []
                                              }
                                              labelMode={"floating"}
                                              wrapItemText={true}
                                              label="Level 2"
                                              searchEnabled={true}
                                              value={reason.level2}
                                              onValueChanged={(e) => {
                                                let matLst = [...materials];
                                                matLst[i]["reasons"][j][
                                                  "level2"
                                                ] = e.value;
                                                matLst[i]["reasons"][j][
                                                  "reasonId"
                                                ] = reason.reasonId;
                                                setMaterial(matLst);
                                              }}
                                            />

                                            <NumberBox
                                              type="number"
                                              labelMode={"floating"}
                                              label="Missed qty"
                                              format="#0"
                                              value={reason.missedQty}
                                              onValueChanged={(e) => {
                                                let matLst = [...materials];
                                                matLst[i]["reasons"][j][
                                                  "missedQty"
                                                ] = e.value;
                                                setMaterial(matLst);
                                              }}
                                              min={0}
                                              width={"15%"}
                                            />

                                            <TextArea
                                              style={{
                                                height: "50px",
                                                padding: "6px",
                                              }}
                                              labelMode={"floating"}
                                              label="Description"
                                              value={reason.description}
                                              maxLength={250}
                                              onValueChanged={(e) => {
                                                let matLst = [...materials];
                                                matLst[i]["reasons"][j][
                                                  "description"
                                                ] = e.value;
                                                setMaterial(matLst);
                                              }}
                                              min={0}
                                            />

                                            <div
                                              className="shft-del-btn"
                                              style={{ marginTop: "14px" }}
                                            >
                                              <span
                                                onClick={() => delReason(i, j)}
                                              >
                                                <i className="dx-link dx-link-delete dx-icon-trash dx-link-icon " />{" "}
                                              </span>
                                              {/*<span>Delete Shift</span> */}
                                            </div>
                                          </div>
                                        );
                                      })}
                                    <div>
                                      {matErrorReq[i] && matErrorReq[i].r && (
                                        <span className="err-lbl">
                                          {matErrorReq[i]["r"]}
                                        </span>
                                      )}
                                    </div>
                                    <div>
                                      {matErrorInfo[i] && (
                                        <span className="err-lbl">
                                          {matErrorInfo[i]}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </ScrollView>
                        <div className="shft-act-btns">
                          <Button
                            text="Save"
                            onClick={handleSave}
                            visible={isEditable}
                          />
                        </div>

                        <br />
                      </div>
                    </Popup>
                  </div>
                </>
              )}
            </>
          }
        </div>
      </div>
    </section>
  );
};

export default OPHDashboard;
